export default __webpack_public_path__ + "static/media/item6.8d14abb3.svg";